/**
 * Audit Sessions Page Header Component
 *
 * Displays the page header with title, description, and create session button.
 * Handles loading states for the create button.
 */

import type { Community } from '@communities/community/domain';
import { SectionHeader } from '@core/components';
import { Button, ButtonType, OverlayMode } from '@soteria/design-system-ve';

interface AuditSessionsPageHeaderProps {
  community: Community | null;
  sessionCount: number;
  isLoading: boolean;
  onCreateSession: () => void;
}

export function AuditSessionsPageHeader({ community, sessionCount, isLoading, onCreateSession }: AuditSessionsPageHeaderProps) {
  return (
    <SectionHeader
      description={
        community ? `Audit and monitor classification performance for ${community.name} content with comprehensive tracking and reporting capabilities.` : ''
      }
      endComponent={
        <Button buttonType={ButtonType.Primary} disabled={isLoading} overlayMode={OverlayMode.Solid} onClick={onCreateSession}>
          CREATE NEW SESSION
        </Button>
      }
      title={community ? `${community.name} Audit Sessions (${sessionCount})` : ''}
    />
  );
}
